import cl1 from '../img/gallery/events-landscape-01.jpg';
import cl2 from '../img/gallery/events-landscape-02.jpg';
import cl3 from '../img/gallery/events-landscape-03.jpg';
import cl4 from '../img/gallery/events-landscape-04.jpg';
import cl5 from '../img/gallery/events-landscape-05.jpg';
import cl6 from '../img/gallery/events-landscape-06.jpg';
import cl7 from '../img/gallery/events-landscape-07.jpg';
import cl8 from '../img/gallery/events-landscape-08.jpg';
import cl9 from '../img/gallery/events-landscape-09.jpg';
import cl10 from '../img/gallery/events-landscape-10.jpg';
import cl11 from '../img/gallery/events-landscape-11.jpg';
import cl12 from '../img/gallery/events-landscape-12.jpg';
import cl13 from '../img/gallery/events-landscape-13.jpg';
import cl14 from '../img/gallery/events-landscape-14.jpg';
import cl15 from '../img/gallery/events-landscape-15.jpg';
import cl16 from '../img/gallery/events-landscape-16.jpg';
import cl17 from '../img/gallery/events-landscape-17.jpg';
import cl18 from '../img/gallery/events-landscape-18.jpg';
import cl19 from '../img/gallery/events-landscape-19.jpg';
import cl20 from '../img/gallery/events-landscape-20.jpg';
import cl21 from '../img/gallery/events-landscape-21.jpg';
import cl22 from '../img/gallery/events-landscape-22.jpg';
import cl23 from '../img/gallery/events-landscape-23.jpg';
import cl24 from '../img/gallery/events-landscape-24.jpg';

import cp1 from '../img/gallery/events-portrait-01.jpg';
import cp2 from '../img/gallery/events-portrait-02.jpg';
import cp3 from '../img/gallery/events-portrait-03.jpg';
import cp4 from '../img/gallery/events-portrait-04.jpg';
import cp5 from '../img/gallery/events-portrait-05.jpg';
import cp6 from '../img/gallery/events-portrait-06.jpg';
import cp7 from '../img/gallery/events-portrait-07.jpg';

import cs1 from '../img/gallery/events-sq-01.jpg';
import cs2 from '../img/gallery/events-sq-02.jpg';
import cs3 from '../img/gallery/events-sq-03.jpg';
import cs4 from '../img/gallery/events-sq-04.jpg';
import cs5 from '../img/gallery/events-sq-05.jpg';

import fl1 from '../img/gallery/finedining-landscape-01.jpg';
import fl2 from '../img/gallery/finedining-landscape-02.jpg';
import fl3 from '../img/gallery/finedining-landscape-03.jpg';
import fl4 from '../img/gallery/finedining-landscape-04.jpg';
import fl5 from '../img/gallery/finedining-landscape-05.jpg';
import fl6 from '../img/gallery/finedining-landscape-06.jpg';
import fl7 from '../img/gallery/finedining-landscape-07.jpg';
import fl8 from '../img/gallery/finedining-landscape-08.jpg';
import fl9 from '../img/gallery/finedining-landscape-09.jpg';
import fl10 from '../img/gallery/finedining-landscape-10.jpg';
import fl11 from '../img/gallery/finedining-landscape-11.jpg';

import fs1 from '../img/gallery/finedining-sq-01.jpg';
import fs2 from '../img/gallery/finedining-sq-02.jpg';
import fs3 from '../img/gallery/finedining-sq-03.jpg';
import fs4 from '../img/gallery/finedining-sq-04.jpg';
import fs5 from '../img/gallery/finedining-sq-05.jpg';
import fs6 from '../img/gallery/finedining-sq-06.jpg';

import wl1 from '../img/gallery/wedding-landscape-01.jpg';
import wl2 from '../img/gallery/wedding-landscape-02.jpg';
import wl3 from '../img/gallery/wedding-landscape-03.jpg';
import wl4 from '../img/gallery/wedding-landscape-04.jpg';
import wl5 from '../img/gallery/wedding-landscape-05.jpg';

export const images = {
    ['Corporate Events']: {
        route: 'corporate-events',
        images: [
            {
                src: cl1,
                dimensions: 'wide',
            },
            {
                src: cs1,
                dimensions: 'big',
            },
            {
                src: cp1,
                dimensions: 'tall',
            },
            {
                src: cl2,
                dimensions: 'wide',
            },
            {
                src: cs2,
                dimensions: 'big',
            },
            {
                src: cp2,
                dimensions: 'tall',
            },
            {
                src: cl3,
                dimensions: 'wide',
            },
            {
                src: cs3,
                dimensions: 'big',
            },
            {
                src: cp3,
                dimensions: 'tall',
            },
            {
                src: cl4,
                dimensions: 'wide',
            },
            {
                src: cs4,
                dimensions: 'big',
            },
            {
                src: cp4,
                dimensions: 'tall',
            },
            {
                src: cl5,
                dimensions: 'wide',
            },
            {
                src: cs5,
                dimensions: 'big',
            },
            {
                src: cp5,
                dimensions: 'tall',
            },
            {
                src: cl6,
                dimensions: 'wide',
            },
            {
                src: cp6,
                dimensions: 'tall',
            },
            {
                src: cl7,
                dimensions: 'wide',
            },
            {
                src: cp7,
                dimensions: 'tall',
            },
            {
                src: cl8,
                dimensions: 'wide',
            },
            {
                src: cl9,
                dimensions: 'wide',
            },
            {
                src: cl10,
                dimensions: 'wide',
            },
            {
                src: cl11,
                dimensions: 'wide',
            },
            {
                src: cl12,
                dimensions: 'wide',
            },
            {
                src: cl13,
                dimensions: 'wide',
            },
            {
                src: cl14,
                dimensions: 'wide',
            },
            {
                src: cl15,
                dimensions: 'wide',
            },
            {
                src: cl16,
                dimensions: 'wide',
            },
            {
                src: cl17,
                dimensions: 'wide',
            },
            {
                src: cl18,
                dimensions: 'wide',
            },
            {
                src: cl19,
                dimensions: 'wide',
            },
            {
                src: cl20,
                dimensions: 'wide',
            },
            {
                src: cl21,
                dimensions: 'wide',
            },
            {
                src: cl22,
                dimensions: 'wide',
            },
            {
                src: cl23,
                dimensions: 'wide',
            },
            {
                src: cl24,
                dimensions: 'wide',
            },
        ],
    },
    ['Social Gatherings']: {
        route: 'social-gatherings',
        images: [
            {
                src: fl1,
                dimensions: 'wide',
            },
            {
                src: fs1,
                dimensions: 'big',
            },
            {
                src: fl2,
                dimensions: 'wide',
            },
            {
                src: fs2,
                dimensions: 'big',
            },
            {
                src: fl3,
                dimensions: 'wide',
            },
            {
                src: fs3,
                dimensions: 'big',
            },
            {
                src: fl4,
                dimensions: 'wide',
            },
            {
                src: fs4,
                dimensions: 'big',
            },
            {
                src: fl5,
                dimensions: 'wide',
            },
            {
                src: fs5,
                dimensions: 'big',
            },
            {
                src: fl6,
                dimensions: 'wide',
            },
            {
                src: fs6,
                dimensions: 'big',
            },
            {
                src: fl7,
                dimensions: 'wide',
            },
            {
                src: fl8,
                dimensions: 'wide',
            },
            {
                src: fl9,
                dimensions: 'wide',
            },
            {
                src: fl10,
                dimensions: 'wide',
            },
            {
                src: fl11,
                dimensions: 'wide',
            },
        ],
    },
    ['Wedding Ceremonies']: {
        route: 'wedding-ceremonies',
        images: [
            {
                src: wl1,
                dimensions: 'wide',
            },
            {
                src: wl2,
                dimensions: 'wide',
            },
            {
                src: wl3,
                dimensions: 'wide',
            },
            {
                src: wl4,
                dimensions: 'wide',
            },
            {
                src: wl5,
                dimensions: 'wide',
            },
        ],
    },
};
